import { Box, Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, IconButton, ImageList, ImageListItem, Menu, MenuItem, Pagination, Paper, Stack, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { T_Inquery } from "../../common/model/InqueryModel";
import { useProgress } from "../../contexts/ProgressContextProvider";
import { T_Page } from "../../common/model/apiModel";
import apis from "../../common/apis";
import { T_Param } from "../../common/model/paramModle";
import { T_Error } from "../../common/model/errorModel";
import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { T_Hand } from "../../common/model/handModel";
import values from "../../common/values";
import { StyledTableCell } from "../../common/style/styles";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";
import CloseIcon from "@mui/icons-material/Close";

export default function HandLoadList(){
    const navigator = useNavigate();

   const [skeyword,setSkeyword]=useState("");
    const pagesize = 10;
    const [page,setPage] = useState(1);
    const [list,setList] =  useState<T_Hand[] | null>(null);
    const {showProgress,setShowProgress} = useProgress();
    const [pageInfo,setPageInfo] = useState<T_Page>()
    const {alert,setAlert} = useAlert();
     
    const [imgDialogOpen, setImgDialogOpen] = useState(false);
    const [currentImg, setCurrentImg] = useState<string>("");

    // 이미지 클릭 핸들러
    const handleImgClick = (url: string) => {
      setCurrentImg(url);
      setImgDialogOpen(true);
    };
    const handleImgClose = () => {
      setImgDialogOpen(false);
      setCurrentImg("");
    };  


    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
      };

 const handleDelete = async(idx:number)=>{

             setAlert({...alert,visible:true,msg:"정말로 삭제 하시겠습니까?",buttonList:[{text:"예",variant:"contained",onPress:async()=>{
      
                const result = await apis.hand.handDelete({idx:idx});
                console.log(result)
                if(result.code=="1"){
                    setAlert(initialAlert);
                    setAlert({...alert,msg:"정상적으로 삭제되었습니다."})
                    getList();
                }else{
                    setAlert(initialAlert);
                    setAlert({...alert,msg:"삭제중 오류가 발생하였습니다다."})
                }
                
        }}
        ,{text:"아니요",variant:"outlined",onPress:()=>{
            setAlert({...alert,visible:false});

        }}
    ]})
  }


    const getList = useCallback(async () => {
        try {
          setShowProgress(true);
          const result = await apis.hand.handList(
            {
              page:Number(page),
              pagesize:pagesize,
            }
          );
          console.log("resut:",result)
            if(result.code=="1"){
            
                setList(result.data.list);
                setPageInfo(result.data);
                setShowProgress(false);
    
            }else{
                 
              setShowProgress(false);
            }
    
       
    
        } catch (err: any) {
          setShowProgress(false);
        }
      }, [page]);

      useEffect(() => {
          getList();
      }, [page]);
    
      

      
     const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
      const [menuRow, setMenuRow] = useState<number | null>(null)
      const open = Boolean(anchorEl);
      const handleClick = (e: React.MouseEvent<HTMLElement>, idx: number) => {
        setAnchorEl(e.currentTarget)
        setMenuRow(idx)
      }   
      const handleClose = () => {
          setAnchorEl(null);
          setMenuRow(null);
        }; 
   

    return(
        <Box sx={{ width: '100%' }}>
      <Card sx={{width:'100%'}} >
        <CardHeader sx={{pr:5,pb:0,mb:0}} title="핸드로드 사용법 관리"  action={
                  <Button variant="outlined" onClick={()=>{
                    navigator("/handy/insert")
                  }}>
                   등록
                  </Button>
                } />
        <CardContent>
        <TableContainer component={Paper}>
      <Table  aria-label="simple table" sx={{width:'100%'}}>
        <TableHead>
          <TableRow>
            <StyledTableCell  sx={{width:'20%',textAlign:'center'}}>제목</StyledTableCell>
            <StyledTableCell align="right"  sx={{textAlign:'center'}}>내용</StyledTableCell>
            <StyledTableCell align="right"  sx={{width:100,textAlign:'center'}}>비고</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>


        {list && list.map((item,index) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <TableCell align="left">{item.title}</TableCell>
               <TableCell align="left"> 
              <Stack direction="row"   sx={{
                rowGap: 2,     // theme.spacing(2) 만큼 세로 간격
                columnGap: 1,  // theme.spacing(1) 만큼 가로 간격
              }} flexWrap="wrap">
  {(item.fileList || []).map((fileitem, idx) => (
            <Box
                          key={idx}
                          sx={{
                            position: 'relative',
                            width: 150,
                            height: 150,
                            border: '1px solid #ddd',
                            borderRadius: 1,
                            overflow: 'hidden',
                          }}
                        onClick={() => handleImgClick(values.server.url+"/upload/"+fileitem.fileUrl)}                          
                        >
                     
      <img
        src={values.server.url+"/upload/"+fileitem.fileUrl}
        alt= {values.server.url+"/"+fileitem.fileUrl}
        loading="lazy"
        style={{padding:5, width: '100%', height: '100%', objectFit: 'cover',border: '1px solid #ddd',}}
      />
     
    </Box>
    
  ))}
  </Stack></TableCell>
              <TableCell align="center">{ <>
                  
                    <IconButton
                      aria-label="menu"
                      onClick={(e) => handleClick(e, index)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={menuRow === index}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleClose()
                          navigator("/handy/edit",{state:{item:item}})  
                        }}
                      >
                        수정
                      </MenuItem>
                      <MenuItem
                        onClick={async() => {
                          handleClose()
                          item.idx && handleDelete(item.idx)
                       //   handleDataDel(item)
                        }}
                      >
                        삭제
                      </MenuItem>
                    </Menu>
                  </>}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
        <Stack   direction="row"
  justifyContent="flex-end"
  alignItems="center" sx={{pt:5,justifyContent:'center',alignContent:'center',justifyItems:'center',alignItems:'ceter'}}>
        <Pagination count={pageInfo?.pages} showFirstButton showLastButton  onChange={handleChange}/>
        </Stack>
        </CardContent>
      </Card>


      {/* 이미지 확대용 Dialog */}
      <Dialog
        open={imgDialogOpen}
        onClose={handleImgClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogActions sx={{ justifyContent: 'flex-end' }}>
          <IconButton onClick={handleImgClose}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
        <DialogContent>
          <Box
            component="img"
            src={currentImg}
            alt="확대 이미지"
            sx={{
              width: '100%',
              height: 'auto',
            }}
          />
        </DialogContent>
      </Dialog>      
      </Box>
    )
}